import { consumer } from "./index"

class NotificationChannel {
  constructor(callbacks = {}) {
    this.callbacks = callbacks
    this.subscription = null
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "NotificationChannel" },
      {
        connected: () => {
          console.log("Connected to notification channel")
          this.callbacks.onConnected?.()
        },

        disconnected: () => {
          console.log("Disconnected from notification channel")
          this.callbacks.onDisconnected?.()
        },

        received: (data) => {
          this.handleReceived(data)
        }
      }
    )

    return this
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  handleReceived(data) {
    if (data.type !== "notification") return

    const notification = data.notification

    switch (notification.kind) {
      case "mention":
        this.callbacks.onMention?.(notification)
        this.showNotification(`${notification.sender_nickname}님이 회원님을 멘션했습니다`, notification.content)
        break
      case "new_message":
        this.callbacks.onNewMessage?.(notification)
        break
      default:
        this.callbacks.onNotification?.(notification)
    }
  }

  showNotification(title, body) {
    // Browser notification if permitted
    if (Notification.permission === "granted") {
      new Notification(title, { body: body })
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          new Notification(title, { body: body })
        }
      })
    }
  }
}

export default NotificationChannel
